import React from "react";
import { Navigate } from "react-router-dom";
import ContainerRedirect from "../../../../../pages/lib/page-redirect";
import ContainerEmptyListComponent from "../../../../../components/container-empty/components/list/page";
import ContainerEmptyAddComponent from "../../../../../components/container-empty/components/add/page";
import ContainerEmptyVideosComponent from "../../../../../components/container-empty/components/videos/page";

export const containerEmptyRoute = [
  {
    path: "list",
    element: <ContainerEmptyListComponent />,
  },
  {
    path: "add",
    element: <ContainerEmptyAddComponent />,
  },
  {
    path: "videos",
    element: <ContainerEmptyVideosComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/container/empty/add" />,
  },
  {
    path: "edit/:id",
    element: <ContainerEmptyAddComponent />,
  },
  {
    path: "",
    element: <ContainerRedirect elroute="/container/empty" />,
  },
];
